import React from 'react';
import Button from '../Button';
import Icon from '../Icon';
import './styles.scss';

const ManagedModal = ({ showModal, onClose }) => {
  return (
    <div
      className={`modal-container ${showModal ? 'show' : ''}`}
      onClick={onClose}
    >
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-buttonContainer">
          <button className="modal-closeButton" onClick={onClose}>
            <Icon name="close" />
          </button>
        </div>
        <div className="modal-body-container">
          <div className="modal-body">
            <h4>Help us, help you...</h4>
            <p>
              The feedback you share will help us to continue to strengthen the{' '}
              <strong>Sustainable Futures</strong> program. Please take a few
              minutes to complete a short survey.
            </p>
            <div className="modal-survey">
              <Button
                target="_blank"
                rel="noopener noreferrer"
                to="https://surveys.discoveryeducation.com/s3/Sustainable-Futures-2023"
                onClick={onClose}
              >
                Take me to the survey!
                <Icon name="arrowright" marginLeft />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManagedModal;
